import React, { useEffect, useRef, useState } from "react";
import mission_men from "../../assets/images/mission_men.png";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const CompanyHistory = () => {
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const headingRef = useRef(null);
  const textRefs = useRef([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const handleImageLoad = () => {
    setIsLoaded(true);
  };

  useEffect(() => {
    if (!isLoaded || !sectionRef.current) return;

    const ctx = gsap.context(() => {
      // Initial hidden state
      gsap.set(
        [imageRef.current, headingRef.current, ...textRefs.current],
        { opacity: 0, y: 40 }
      );

      gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 75%",
          toggleActions: "play none none none",
        },
      })
        .to(imageRef.current, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power3.out",
        })
        .to(
          headingRef.current,
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power3.out",
          },
          "-=0.4"
        )
        .to(
          textRefs.current,
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.2,
            ease: "power3.out",
          },
          "-=0.5"
        );
    }, sectionRef);

    return () => {
      ctx.revert();
      ScrollTrigger.getAll().forEach(t => t.kill());
    };
  }, [isLoaded]);

  const addToRefs = (el) => {
    if (el && !textRefs.current.includes(el)) {
      textRefs.current.push(el);
    }
  };

  return (
    <section ref={sectionRef} className="w-full py-[60px] md:py-[80px] bg-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 md:grid-rows-1 gap-[40px] md:gap-[70px] items-center">

          {/* Image */}
          <div className="rounded-[20px] overflow-hidden shadow-lg group">
            <img
              ref={imageRef}
              src={mission_men}
              alt="Team members discussing field strategy"
              onLoad={handleImageLoad}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>

          {/* Text */}
          <div>
            <h2 
              ref={headingRef}
              className="text-[28px] lg:text-[44px] md:text-[32px] font-bold md:mb-6 mb-[16px] font-[LTWave] text-[#222222]"
            >
              About Agastya Agro Limited
            </h2>
            <p 
              ref={addToRefs}
              className="text-[#6C6C6C] text-base md:text-lg font-regular font-inter mb-[12px] leading-relaxed"
            >
              Agastya Agro Limited is a leading pesticide formulation company with
              25+ years of steady growth. With a strong focus on innovation,
              compliance, and farmer-centric solutions, we serve over 1 million
              farmers through 2,500 retailers, 5,000 dealers, and 15 branches
              across India.
            </p>
            <p 
              ref={addToRefs}
              className="text-[#6C6C6C] text-base md:text-lg font-regular font-inter leading-relaxed"
            >
              With over 27 years of hands-on experience, we specialise in
              delivering science-backed, sustainable agri-inputs from soil health
              enhancers and plant nutrition products to crop protection solutions
              that help farmers increase productivity while reducing environmental
              and economic risks.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CompanyHistory;
